import { i18n } from "@/setup/i18n-setup";
import { UserConfigService } from "@/services/user-config-service";

export interface DefaultEditTab {
	key: string;
	label: () => string;
	required?: boolean;
}

function fromKey(path: string): () => string {
	return () => i18n.t(path).toString();
}

function fromArray(path: string, index: number): () => string {
	return () => {
		let values = Object.values(i18n.t(path) as any);
		return `${values[index] || ""}`;
	};
}

const CONTACT_TABS: DefaultEditTab[] = [
	{key: "general", label: fromArray("components.contacts.tabs", 0), required: true},
	{key: "addresses", label: fromArray("components.contacts.tabs", 1)},
	{key: "extra-info", label: fromArray("components.contacts.tabs", 2)},
	{key: "extra-fields", label: fromArray("components.contacts.tabs", 3)},
	{key: "documents", label: fromArray("components.contacts.tabs", 4)},
	{key: "price-rules", label: fromArray("components.contacts.tabs", 5)}
];

const PRODUCT_TABS: DefaultEditTab[] = [
	{key: "general", label: fromKey("components.products.tabs.general"), required: true},
	{key: "buy", label: fromKey("components.products.tabs.buy")},
	{key: "stock", label: fromKey("components.products.tabs.stock")},
	{key: "extra-fields", label: fromKey("components.products.tabs.extra-fields")},
	{key: "taxes", label: fromKey("components.products.tabs.taxes")},
	{key: "documents", label: fromKey("components.products.tabs.documents")},
	{key: "price-rules", label: fromKey("components.products.tabs.price-rules")},
	{key: "label-settings", label: fromKey("components.products.tabs.label-settings")}
];

const PURCHASE_TABS: DefaultEditTab[] = [
	{key: "default", label: fromKey("components.purchases.tabs.default"), required: true},
	{key: "extra-fields", label: fromKey("components.purchases.tabs.extra-fields")},
	{key: "purchase-validation", label: fromKey("components.purchases.tabs.purchase-validation")}
];

const CRM_TABS: DefaultEditTab[] = [
	{key: "activities", label: fromKey("components.crm.tabs-created.activities"), required: true},
	{key: "documents", label: fromKey("components.crm.tabs-created.documents")},
	{key: "extra-fields", label: fromKey("components.crm.tabs-created.extra-fields")},
	{key: "files", label: fromKey("components.crm.tabs-created.files")}
];

const CAR_TABS: DefaultEditTab[] = [
	{key: "general", label: fromArray("components.cars.InfoTabs", 0), required: true},
	{key: "files", label: fromArray("components.cars.InfoTabs", 1)},
	{key: "extra-fields", label: fromArray("components.cars.InfoTabs", 2)}
];

const PROJECT_TABS: DefaultEditTab[] = [
	{key: "general", label: fromKey("components.project.tabs.general"), required: true},
	{key: "extra-fields", label: fromKey("components.project.tabs.extra-fields")},
	{key: "documents", label: fromKey("components.project.tabs.documents")}
];

export const DEFAULT_EDIT_TABS: {[browseId: number]: DefaultEditTab[]} = {
	1: CONTACT_TABS,
	2: CONTACT_TABS,
	3: CONTACT_TABS,
	4: PRODUCT_TABS,
	9: PURCHASE_TABS,
	11: CRM_TABS,
	13: CAR_TABS,
	23: PROJECT_TABS
};

export function getDefaultEditTabs(browseId: number): DefaultEditTab[] {
	return DEFAULT_EDIT_TABS[browseId] || [];
}

export function getVisibleDefaultEditTabs(browseId: number, filter?: (tab: DefaultEditTab) => boolean): DefaultEditTab[] {
	let hidden = UserConfigService.getEditTabSettings().getHiddenTabs(browseId);
	return getDefaultEditTabs(browseId).filter(tab => {
		if (!tab.required && hidden.indexOf(tab.key) != -1) return false;
		return !filter || filter(tab);
	});
}
